import Logo from './Logo';
import styles from './LogoSection.module.css';

export default function LogoSection() {
  return (
    <div className={styles.logoSection}>
      <Logo />
    </div>
  );
} 